import { createFileRoute } from '@tanstack/react-router';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Activity } from 'lucide-react';

export const Route = createFileRoute('/_dashboard/admin/superadmin/system')({
  component: SuperAdminSystemPage,
});

function SuperAdminSystemPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">System Health</h1>
        <p className="text-muted-foreground">Monitor platform services and performance</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Activity className="h-5 w-5" />
            Service Status
          </CardTitle>
          <CardDescription>Real-time health monitoring</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">System health dashboard coming soon...</p>
        </CardContent>
      </Card>
    </div>
  );
}
